import { useEffect, useState } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";
import { AttachmentPreviews } from "./AttachmentPreviews";
import { LinkPreviews } from "./LinkPreviews";
import { getMarksByType } from "./utilities/getMarks";

export const PreviewBlocks = () => {
  const {
    editor,
    attachments = [],
    localAttachments = [],
    messageAttachments,
  } = useTipTapEditorContext();

  const attachmentsList = editor.isEditable ? localAttachments : attachments;
  const linkMarks = getMarksByType({ editor, type: "link" });

  const linkMarksLength = Number(linkMarks.length);
  const attachmentsLength = Number(attachmentsList?.length);
  const messageAttachmentsLength = Number(messageAttachments?.length);

  const [hasLinks, setHasLinks] = useState<boolean>(false);

  const hasAttachments = attachmentsLength > 0;
  const hasMessageAttachments = messageAttachmentsLength > 0;

  useEffect(() => {
    setHasLinks(linkMarksLength > 0);
  }, [linkMarksLength]);

  if (!hasAttachments && !hasLinks && !hasMessageAttachments) {
    return null;
  }

  const totalAttachmentCount =
    linkMarksLength + attachmentsLength + messageAttachmentsLength;

  const isEditMode = editor.isEditable;
  return (
    <div
      className={classNames(
        "flex gap-x-2",
        isEditMode ? "items-center pt-4" : "flex-col items-start pt-2",
        {
          "overflow-x-auto": totalAttachmentCount > 2,
        },
      )}
    >
      <AttachmentPreviews attachmentsList={attachmentsList} />
      <LinkPreviews
        linkMarks={linkMarks}
        setHasLinks={setHasLinks}
        messageAttachments={messageAttachments}
        hasAttachments={hasAttachments}
        isEditMode={isEditMode}
      />
    </div>
  );
};
